import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_BROWN,
  FORTA_ERROR,
  FORTA_GRAY3,
  FORTA_GRAY5,
  FORTA_ORANGE,
  FORTA_PINK,
  FORTA_PURPLE,
  FORTA_SKY_BLUE,
  FORTA_SUCCESS,
  FORTA_YELLOW,
} from '../../../utils/colors';

/** Palette offered in the toolbar's text-color picker. */
export const QUILL_TEXT_COLORS = [
  FORTA_BLACK,
  FORTA_GRAY5,
  FORTA_GRAY3,
  FORTA_BLUE.dark,
  FORTA_BLUE.primary,
  FORTA_BLUE.bright,
  FORTA_SKY_BLUE,
  FORTA_SUCCESS,
  FORTA_YELLOW,
  FORTA_ORANGE,
  FORTA_BROWN,
  FORTA_ERROR,
  FORTA_PINK,
  FORTA_PURPLE,
];

/** Toolbar layout limited to the supported formatting controls. */
export const QUILL_TOOLBAR_MODULES = {
  toolbar: [
    [{ color: QUILL_TEXT_COLORS }],
    ['bold', 'underline', 'italic'],
    [{ list: 'bullet' }, { list: 'ordered' }],
  ],
};

/** Formats Quill is allowed to apply — anything pasted outside this set is stripped. */
export const QUILL_FORMATS = ['bold', 'italic', 'underline', 'list', 'color'];

/** Quill emits this markup for an otherwise-empty editor. */
export const EMPTY_QUILL_HTML = '<p><br></p>';

export const DEFAULT_QUILL_EDITOR_MIN_HEIGHT = 160;
